
export default function forceLogout() {
    if (localStorage.getItem("wallet_connected")) {
        localStorage.removeItem("wallet_connected");
    }
    document.cookie = 'AuthorizationGoatech=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    window.location.href = "/";
}